<gtd-notifications></gtd-notifications>
<gtd-header-component
  [title]="isResetPassword ? 'Restore password' : 'Login to Account'"
  [isAuthorized]="isAuthorized"
></gtd-header-component>

<main class="l-base">
  <section class="c-login">
    <div class="c-login__form c-form">
      <form *ngIf="!isAuthorized && !isResetPassword" [formGroup]="form" (ngSubmit)="submit()" class="c-form__body">
        <div class="c-form__icon--account"></div>

        <ng-container *ngIf="!is2fa">
          <p class="c-form__title"><span class="c-form__sign-in">Sign in to IREV</span></p>
          <div class="c-form__row mb-36">
            <div class="c-form-legend" [ngClass]="{ 'is-error': (login.invalid && login.touched) || (isSubmitted && !isAuthorized) }">
              <fieldset>
                <input type="text" placeholder="Enter email" required="required" name="text" [formControl]="login" />
                <legend>Email</legend>
                <ng-container *ngIf="login.invalid && login.touched ? errorTextBuilder(login) : '' as errorText">
                  <div class="c-form-field__msg -error">{{ errorText }}</div>
                </ng-container>
              </fieldset>
            </div>
          </div>
          <div class="c-form__row mb-36">
            <div class="c-form-legend" [ngClass]="{ 'is-error': (password.invalid && password.touched) || (isSubmitted && !isAuthorized) }">
              <fieldset>
                <input
                  [type]="isVisible ? 'text' : 'password'"
                  placeholder="Enter password"
                  required="required"
                  name="password"
                  [formControl]="password"
                />
                <legend>Password</legend>
                <button
                  type="button"
                  class="eye"
                  [class.-active]="isVisible"
                  [hidden]="!password.value?.length"
                  (click)="isVisible = !isVisible"
                >
                  <i class="icon icon-eye"></i>
                </button>
                <ng-container *ngIf="password.invalid && password.touched ? errorTextBuilder(password) : '' as errorText">
                  <div class="c-form-field__msg -error">{{ errorText }}</div>
                </ng-container>
              </fieldset>
            </div>
          </div>
          <div class="c-form__row">
            <div class="c-form-legend">
              <fieldset class="no-background pb-0 pt-0">
                <div class="c-form-field mb-1" *ngFor="let agreement of agreements">
                  <p500-ui-checkbox-field [id]="agreement.id" [formControlName]="'agreement_' + agreement.id" [hidden]="!showAgreements">
                    <ng-template p500UIFieldLabel>
                      <span class="p500-ui-form-field__label d-flex align-items-start">
                        <span class="mr-1 d-inline-block text-nowrap">
                          I agree with
                           <a class="text-wrap" [attr.href]="agreement.url" target="_blank">
                            {{ agreement.title }}
                        </a>
                        </span>

                      </span>

                    </ng-template>
                  </p500-ui-checkbox-field>
                </div>
              </fieldset>
            </div>

          </div>
          <div *ngIf="isSubmitted && !isAuthorized" class="c-form__row mb-0">
            <div class="c-form-field is-error">
              <div class="c-form-field__message">
                Authorization failed. Something went wrong.<br />
                Try again or
                <span class="c-link" (click)="resetPasswordToggle()">recover your password.</span>
              </div>
            </div>
          </div>
          <div class="c-form__row c-form__row--submit mt-22">
            <button type="submit" class="c-button c-button--primary -large -full" [ngClass]="{'is-disabled': form.invalid}">
              Sign in
              <span class="c-button__icon icon-arrow-1"></span>
            </button>
          </div>
          <div class="c-form__row c-form__footer c-form__footer--center">
            <!-- <a class="c-form__footer-link" routerLink="/auth/wizard">Create new account</a> -->
            <!-- <div class="c-form__separator"></div> -->
            <button class="c-button c-link c-form__footer-link" type="button" (click)="resetPasswordToggle()">Forgot Password?</button>
          </div>
        </ng-container>

        <ng-container *ngIf="is2fa && !isResetPassword">
          <div class="c-form__header">
            <div *ngIf="tfaType === 'Telegram'; else we_sent_code" class="c-form__subtitle">
              2FA was sent from: <a href="https://t.me/irev_com_bot" target="_blank">&#64;irev_com_bot</a>
            </div>
            <ng-template #we_sent_code>
              <div class="c-form__subtitle">2FA was sent to you</div>
            </ng-template>
          </div>
          <div class="c-form__row">
            <gtd-form-field-confirm-code
              formControlName="token_2fa"
              [lengthCode]="codeLength"
              [cssClass]="{ 'is-error': (token2fa.invalid && token2fa.touched) || (isSubmitted && !isAuthorized) }"
            >
            </gtd-form-field-confirm-code>
          </div>
          <div class="c-form__row">
            <div class="c-form-field">
              <div class="c-form-field__message">
                This page is protected by Two-factor authentication:<br />We sent code to your <strong>{{ tfaType }}</strong>
              </div>
            </div>
          </div>
          <div class="c-form__row c-form__row c-form__row--submit">
            <button type="submit" class="c-button c-button--primary -large -full">
              Confirm
              <span class="c-button__icon icon-arrow-1"></span>
            </button>
          </div>
          <div class="c-form__footer c-form__footer--center">
            Support:&nbsp;<a class="c-form__footer-link--blue" href="mailto:support@irev.com" target="_blank">support&#64;irev.com</a>
          </div>
        </ng-container>
      </form>

      <gtd-authorized-component *ngIf="isAuthorized"></gtd-authorized-component>
      <gtd-reset-password-component
        *ngIf="isResetPassword"
        (resetEmail)="resetEmailToggle()"
        (resetConfirm)="resetConfirmToggle()"
        (back)="resetPasswordToggle()"
      ></gtd-reset-password-component>
    </div>
    <div class="signin-bg"></div>
  </section>

  <section *ngIf="isJwtAuthIframeUrlsInited" class="c-iframe">
    <ng-container *ngFor="let item of jwtAuthIframeUrls; trackBy: trackByFn">
      <iframe #jwtAuthIframeEl class="c-iframe__body--hidden" [src]="item"> </iframe>
    </ng-container>
  </section>

  <gtd-across-iframe></gtd-across-iframe>
</main>
